import { CampaignMediaTypes } from '@features/campaigns/shared/types/campaign.ts';
import { ListCreatableMediaTypesResponse } from '@features/campaigns/shared/types/creatableMediaTypes.ts';

export const mockedCreatableMediaTypes: ListCreatableMediaTypesResponse = {
  mediaTypes: [CampaignMediaTypes.CTV, CampaignMediaTypes.THEMATIC],
};

export const mockedCreatableMediaTypesWithoutThematic: ListCreatableMediaTypesResponse = {
  mediaTypes: [CampaignMediaTypes.CTV],
};
